import { where } from "firebase/firestore"
import _ from 'lodash'
import { convertHelpers, getFirstObject } from "../../../../../global/common/convert"
import { formatItem, formatTypes } from "../../../../../global/common/dateFormatting"
import { getLastItem, getLastItemSortedByKey } from "../../../../../global/common/filtering"
import { createRefPath_event } from "../../../../../global/firestoreData/appData/appRefPaths"
import { sortDB } from "../../../helpers/league"
import { matchCalcs } from "../../../helpers/match"
import { _matchLsTypes, matchStatusTypes } from "../SportsDataReducer"
import { gameScoringTypes } from "../SportsSeasonReducer"
import { _sportCollections } from "../SportsSidebarReducer"
import { seasonalHelpers } from "./seasonalSportsData"
import { realtimeDocumentTypes } from "../SportsEditMatchReducer"
import { removeFromObjects } from "../../../../../global/common/sorting"
import { createInitials } from "../../../../../global/common/dataAdjust"
import { ammendTeamName } from "../SportsMatchReducer"

const _pendingPrefix = 'playoffMatches.'

const ammendMatchDayMatches = (matches_matchDay, matches_combined) => {
  const matches_match_day = {}
  _.forEach(matches_matchDay, (mmd, mmdKey) => {
    _.forEach(mmd, (mmdd, appUserKey) => {
      matches_match_day[mmdKey] = {
        results: mmdd.results,
        _scorer: appUserKey,
      }
    })
  })
  const matches = {}
  _.forEach(matches_match_day, (match_md, matchKey) => {
    if (matches_combined[matchKey] && match_md.results) {
      matches[matchKey] = {
        ...matches_combined[matchKey],
        results: match_md.results,
        _scorer: match_md._scorer
      }
    }
  })
  ammendMatchesCollectionKeys(matches)
  return matches
}


const createMatchUpdateData = (matches) => {
  const updates = {}
  const _levelMatches = _.groupBy(matches, '_matchCollectionKey')
  _.forEach(_levelMatches, (levelMatches, levelKey) => {
    _.forEach(levelMatches, (levelMatch, matchKey) => {
      if (!updates[levelKey]) updates[levelKey] = {} // ✅ initialize object
      const { isPlayoff, _itemKey } = levelMatch
      const _matchPrefix = isPlayoff ? 'playoffMatches' : 'matches'
      if (!levelMatch.teams && levelMatch?.away?.id && levelMatch?.home?.id) {
        levelMatch.teams = [levelMatch.away.id, levelMatch.home.id]
      }
      updates[levelKey][_matchPrefix + '.' + _itemKey] = levelMatch
    })

  })
  return updates
}

const ammendMatchesCollectionKeys = (matches) => {
  _.forEach(matches, (match, matchKey) => {
    if (!match._matchCollectionKey) {

      const { home, away } = match ?? {}

      const bothHaveIds = home?.id && away?._id;
      const sameLevel = home?.levels === away?.levels;
      const sameSection = home?.sections === away?.sections;

      let _matchCollectionKey = _matchLsTypes.Non;

      if (sameLevel && sameSection) {
        _matchCollectionKey = home.levels;
      } else if (!bothHaveIds) {
        _matchCollectionKey = _matchLsTypes.nonDistrict;
      } else if (sameLevel) {
        _matchCollectionKey = home.levels;
      }
      match._matchCollectionKey = _matchCollectionKey
    }
  })
}

const copyTeamDataToClipboard = (teams, propToCopy = ['seed', 'name']) => {
  const headers = propToCopy.map(prop => _.last(prop.split('.')));
  const data = _.map(teams, team => _.map(propToCopy, prop => _.get(team, prop, '')));
  const formattedData = [headers, ...data]
    .map(row => row.join('\t'))
    .join('\n');

  navigator.clipboard.writeText(formattedData).then(() => {
    console.log('Data copied to clipboard');
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
};

function getAllConsonants(text) {
  // Define a regular expression for consonants (non-vowel alphabets)
  const consonants = /[^aeiouAEIOU]/;
  // Filter out consonants from the text
  const result = [...text].filter(char => consonants.test(char)); // Convert text to array and filter 
  return result.join(''); // Return the consonants as a string
}

const isDirection = (text) => {
  const d = ['NORTH', 'SOUTH', 'WEST', 'EAST']
  return d.includes(text)
}

function getConsonant(text, last, sc) {
  // Define a regular expression for consonants (non-vowel alphabets)
  const consonants = /[^aeiouAEIOU]/;
  // Skip the first 3 characters
  const remainingText = text.slice(sc ? sc : 3);
  // Find the first consonant in the remaining text
  if (last) {
    // Find the last consonant in the remaining text
    for (let i = remainingText.length - 1; i >= 0; i--) {
      if (consonants.test(remainingText[i])) {
        return remainingText[i]; // Return the last consonant found
      }
    }
  } else {
    // Find the first consonant in the remaining text
    for (let i = 0; i < remainingText.length; i++) {
      if (consonants.test(remainingText[i])) {
        return remainingText[i]; // Return the first consonant found
      }
    }
  }

  return null; // Return null if no consonant is found
}

const createTeamInitials = (teams) => {

  function dotCount(text) {
    const matches = text.match(/\./g); // Match all periods
    return matches ? matches.length : 0; // Return the number of matches, or 0 if no periods are found
  }

  const applyInits = (_teams, count) => {
    _.forEach(_teams, (team) => {
      const { name } = team
      const dc = dotCount(name)
      const words = name.split(' ').map(word => word.toUpperCase());

      const ws = {
        firstWord: words[0],
        secondWord: words[1],
        thirdWord: words[2],
        firstWord_1: '',
        firstWord_2: '',
        firstWord_3: '',
        secondWord_1: '',
        secondWord_2: '',
        secondWord_3: '',
        thirdWord_1: '',
        thirdWord_2: '',
        thirdWord_3: '',
      }

      for (let i = 0; i <= 2; i++) {
        ws['firstWord_' + (i + 1)] = ws.firstWord && ws.firstWord[i]
      }

      for (let i = 0; i <= 2; i++) {
        ws['secondWord_' + (i + 1)] = ws.secondWord && ws.secondWord[i]
      }

      for (let i = 0; i <= 2; i++) {
        ws['thirdWord_' + (i + 1)] = ws.thirdWord && ws.thirdWord[i]
      }

      let initials;
      if (dc > 1) {
        initials = name.replace(/[^A-Z]/g, '');
      } else {
        switch (words.length) {
          case 1:
            const first3 = name.slice(0, 3).toUpperCase()
            const ac = getAllConsonants(name)
            const ltc = ac.slice(-2)
            const fc = getConsonant(name, false)
            const fc3 = getConsonant(name, false, 2)
            const lc = getConsonant(name, true)
            const _fc = fc ? fc : fc3
            switch (count) {
              case 0:
                initials = first3
                break;
              case 1:
                initials = first3 + _fc.toUpperCase()
                break;
              default:
                initials = first3 + ltc.toUpperCase()
            }
            break;
          case 2:
            const firstWord_lc = getConsonant(ws.firstWord, true)
            const firstWord_lc3 = getConsonant(ws.firstWord, true, 2)
            const _firstWord_lc2 = firstWord_lc ? firstWord_lc : firstWord_lc3
            switch (count) {
              case 0:
                initials = ws.firstWord_1 + ws.secondWord_1
                break;
              case 1:
                if (isDirection(ws.firstWord)) {
                  initials = ws.firstWord_1 + ws.secondWord_1;
                } else {
                  initials = ws.firstWord_1 + _firstWord_lc2 + ws.secondWord_1;
                }
                break;
              default:
                initials = ws.firstWord_1 + ws.firstWord_2 + _firstWord_lc2 + ws.secondWord_1;
            }
            break;
          case 3:
            switch (count) {
              case 0:
                initials = ws.firstWord_1 + ws.secondWord_1 + ws.thirdWord_1;
                break;
              case 1:
                initials = ws.firstWord_1 + ws.secondWord_1 + ws.thirdWord_1 + ws.thirdWord_2;
                break;
              default:
                initials = ws.firstWord_1 + ws.secondWord_1 + ws.thirdWord_1 + ws.thirdWord_2;
            }
            break;
        }
      }

      team.initials = initials
    })
  }

  applyInits(teams, 0)

  let done = false
  let count = 0;

  while (!done) {
    const _teams = _.groupBy(teams, 'initials')
    const _teamsMulti = _.filter(_teams, (group) => group.length > 1);
    const tc = _teamsMulti.length
    if (tc === 0 || count > 3) {
      done = true
    } else {
      count++
      _.forEach(_teamsMulti, (tm) => {
        applyInits(tm, count)
      })
    }
  }
}


const createSportAbr = (sport, year) => {
  const _smssc = _.startCase(sport)
  let _abr = createInitials(_smssc)
  if (_smssc.indexOf('Basket') > 0) { _abr += 'K' }
  if (_smssc.indexOf('Base') > 0) { _abr += 'S' }
  if (_smssc.indexOf('ball') > 0) { _abr += 'B' }
  if (_smssc.indexOf('crosse') > 0) { _abr += 'X' }
  return year ? _abr + '_' + year : _abr
}

const ammendMatchTeamNames = (matches, teams, forPlayoffs) => {
  const updates = {}
  const matchType = forPlayoffs ? 'playoffMatches' : 'matches'
  const ammendNames = (homeOrAway) => {
    const amendMatchNames = (matchGroups, property) => {
      _.forEach(matchGroups, (groupedMatches, matchKey) => {
        if (!matchKey || matchKey === 'undefined') return;

        const team = _.find(teams, { name: matchKey });
        if (!team) {
          const amendedName = ammendTeamName(matchKey);
          _.forEach(groupedMatches, (match) => {
            const { levels, _itemKey } = match
            if (amendedName !== matchKey) {
              _.set(match, property, amendedName);
              if (!updates[levels]) { updates[levels] = {} }
              updates[levels][matchType + '.' + _itemKey] = match
            }
          });
        }
      });
    };

    const teamMatches = _.groupBy(matches, match => _.get(match, `${homeOrAway}.name`));
    amendMatchNames(teamMatches, `${homeOrAway}.name`);

    const locationMatches = _.groupBy(matches, match => match.location?.name);
    amendMatchNames(locationMatches, 'location.name');
  };

  ammendNames('away');
  ammendNames('home');
};

const ammendMatchesFromDbResults = (rtms, matches_info, realtimeDocumentType, gameScoringType) => {

  let _statusProp;

  const { matches, matches_playoffs } = matches_info ?? {}

  switch (realtimeDocumentType) {
    case realtimeDocumentTypes.matchDay:
      _statusProp = 'isMatchDayResult'
      break;
    case realtimeDocumentTypes.realtime:
      _statusProp = 'isRealtimeResult'
      break;
    default:
    // nothing
  }

  // cLear the mathes of any priop
  removeFromObjects(matches, ['_results_realtime'])
  removeFromObjects(matches_playoffs, ['_results_realtime'])

  if (_statusProp) {

    const matchDayMatches = matches ? _.filter(matches, match => _.get(match, `_status.${_statusProp}`, false) === true) : [];
    const matchDayMatches_playoff = matches_playoffs ? _.filter(matches_playoffs, match => _.get(match, `_status.${_statusProp}`, false) === true) : [];

    _.forEach(matchDayMatches, (mdm) => {
      if (mdm._status) { mdm._status[_statusProp] = false }
      if (mdm._results) { delete mdm._results.score }
      matchCalcs.calcVballMatch(mdm, gameScoringType)
    })

    _.forEach(matchDayMatches_playoff, (mdm) => {
      if (mdm._status) { mdm._status[_statusProp] = false }
      if (mdm._results) { delete mdm._results.score }
      matchCalcs.calcVballMatch(mdm, gameScoringType)
    })
  }

  /**
   * 
   * @param {object} _matches 
   * @param {*} mr 
   * @param {*} mk 
   */
  const updateMatchWithDbMatcheResults = (_matches, mr, mk) => {
    if (_matches && _matches[mk]) {
      const match_actual = _matches[mk]
      const { home, away } = match_actual ?? {}
      const rtm = getFirstObject(mr)
      const { item: item_rt } = rtm ?? {}
      const { displayName, results: results_rt } = item_rt ?? {}
      const match_rt = { home, away, results: results_rt }
      matchCalcs.calcVballMatch(match_rt, gameScoringType)
      const { _results } = match_rt ?? {}
      switch (realtimeDocumentType) {
        case realtimeDocumentTypes.matchDay:
          match_actual._results_matchDay = _results
          match_actual._scorer = createInitials(displayName)
          match_actual._hasMatchDay = true
          // console.log('adjusted results', realtimeDocumentType, match_actual)
          break;
        case realtimeDocumentTypes.realtime:
          match_actual._results_realtime = _results
          match_actual._scorer = createInitials(displayName)
          match_actual._hasRealtime = true
          // console.log('adjusted results', realtimeDocumentType, match_actual)
          break;
        default:
        // nothing
      }
    }
  }

  _.forEach(rtms, (mr, mk) => {
    updateMatchWithDbMatcheResults(matches, mr, mk)
    updateMatchWithDbMatcheResults(matches_playoffs, mr, mk)
  })

  matchCalcs.calcAllVballMatches_displays(matches)
  matchCalcs.calcAllVballMatches_displays(matches_playoffs)

}

const getWheres_sports = (pathViews, dataItemDirect, sportsKey) => {

  const { parentKeys } = dataItemDirect ?? {}

  // get the sport
  const wheres = []
  const _wheres = []

  parentKeys.forEach(parentKey => {
    switch (parentKey) {
      case 'name':
        wheres.push(where("name", "==", _.startCase(pathViews.sports)))
        _wheres.push({ name: _.startCase(pathViews.sports) })
        break;
      default:
        if (pathViews[parentKey]) {
          switch (parentKey) {
            case 'sports':
              wheres.push(where('parentKeys.' + parentKey, '==', sportsKey))
              _wheres.push({ [parentKey]: sportsKey })
              break;
            default:
              wheres.push(where('parentKeys.' + parentKey, '==', pathViews[parentKey]))
              _wheres.push({ [parentKey]: pathViews[parentKey] })
          }
        }
    }
  })

  return { wheres, _wheres }

}

const getMatchDateKeys = (matchDateGroups) => {
  const today = new Date()
  const _today = formatItem(formatTypes.shortestDate, today)

  let _todaysMatchCount;
  const matchDateKeys = []
  const matchDateKeys_count = {}

  if (matchDateGroups) {
    matchDateGroups.forEach(group => {
      matchDateKeys.push(group.matchDate)
      matchDateKeys_count[group.matchDate] = Object.keys(group.matches).length
      if (group.matchDate === _today) {
        _todaysMatchCount = Object.keys(group.matches).length
      }
    })
  }
  return { matchDateKeys, matchDateKeys_count, _todaysMatchCount }
}

const getTeams_flat = (teams) => {
  const _teamsFlat = {}
  _.forEach(teams, (team, tk) => {
    const tf = getTeam_flat(team)
    if (mf) { _teamsFlat[tk] = tf }
  })
  return _teamsFlat
}


const getTeam_flat = (team) => {

}

/**
 * 
 * @param {object} matches_season 
 * @returns the same list of matches, but converts the home, away and results object to props without the object
 */
const getMatches_flat = (matches_season, flattenResult) => {
  const _matchesFlat = {}
  _.forEach(matches_season, (ms, mk) => {
    const mf = getMatch_flat(ms, false, flattenResult)
    if (mf) { _matchesFlat[mk] = mf }
  })
  return _matchesFlat
}

const getMatch_flat = (ms, allowMatchStatusType, flattenResult) => {

  const {
    _matchCollectionKey,
    _matchStatusTypes,
    _results,
    _status,
    away,
    home,
    isPlayoff,
    levels,
    location,
    matchNumber,
    old,
    pending,
    poolKey,
    results,
    sections,
    startDate,
    startTime,
  } = ms

  const _theResults = _results || results

  const { isBye } = _status ?? {}
  const { score, scores } = _results ?? {}
  // const { score, scores } = _results ?? {}
  const { home: score_home, away: score_away } = score ?? {}

  if (!isBye) {

    const _ms = {
      home: home ? home.name : '?',
      away: away ? away.name : '?',
      sections: sections,
      section: sections,
      levels: levels,
      level: levels,
      startDate,
      _matchCollectionKey,
      isPlayoff: isPlayoff ? true : false,
    }

    if (_.isNumber(score_home)) { _ms.homeScore = parseInt(score_home) }
    if (_.isNumber(score_away)) { _ms.awayScore = parseInt(score_away) }
    if (results) { _ms._results = results }
    if (results) { _ms.results = results }
    if (old) { _ms.old = old }
    if (allowMatchStatusType) { _ms._matchStatusTypes = _matchStatusTypes }
    if (!_ms._matchStatusTypes) { _ms._matchStatusTypes = [matchStatusTypes.existingDb] }

    if (isPlayoff) {
      _ms.startTime = startTime
      _ms.poolKey = poolKey
      _ms.matchNumber = matchNumber
      if (away && away.seed) { _ms.awaySeed = away.seed }
      if (home && home.seed) { _ms.homeSeed = home.seed }
    }

    if (pending) {
      const { home: home_pending, away: away_pending } = pending
      if (!home) {
        _ms.homeSeed = home_pending.originalSeed
        _ms.home = home_pending.place + ' ' + home_pending.poolName + ' match #' + home_pending.matchNumber
      }
      if (!away) {
        _ms.awaySeed = away_pending.originalSeed
        _ms.away = away_pending.place + ' ' + away_pending.poolName + ' match #' + away_pending.matchNumber
      }
    }

    if (scores) {
      Object.keys(scores).forEach(sn => {
        const sc = scores[sn]
        _ms['away' + sn] = parseInt(sc.away)
        _ms['home' + sn] = parseInt(sc.home)
      })
    }

    if (location) {
      _ms.location = location.name
    }

    if (flattenResult && _ms.results && _ms.results.score) {
      if (_ms.results.score.away) {
        _ms.awayScore = _ms.results.score.away
      }
      if (_ms.results.score.home) {
        _ms.homeScore = _ms.results.score.home
      }
      delete _ms.results
      delete _ms._results
    }
    return _ms
  }
}

const getSportSeasonType = (sportsModeKey) => {

  let _sms = sportsModeKey
  const _abr = sportsHelpers.createSportAbr(_sms)

  let _sportsSeasonType;

  _sms = _sms.replace('womens', '')
  _sms = _sms.replace('mens', '')
  _sms = _sms.toLowerCase()
  switch (_sms) {
    case 'soccer':
    case 'football':
      _sportsSeasonType = 'fall'
      break;
    case 'basketball':
      _sportsSeasonType = 'winter'
      break;
    case 'baseball':
    case 'softball':
      _sportsSeasonType = 'spring'
      break;
    default:
  }

  const { gameScoringType, gameAllowTies } = getScoreType(sportsModeKey)

  return {
    gameScoringType,
    gameAllowTies,
    _sportsAbr: _abr,
    _sportsModeSport: _sms,
    _sportsSeasonType
  }
}

const getScoreType = (sportsModeKey) => {

  let _sportsModeKey = sportsModeKey.replace('womens', '')
  _sportsModeKey = _sportsModeKey.replace('mens', '')
  _sportsModeKey = _sportsModeKey.toLowerCase()

  const matchTypes = ['volleyball', 'tennis']
  const halfTypes = ['soccer', 'fieldHockey', 'lacrosse']
  const quarterTypes = ['basketball', 'football']
  const inningTypes = ['baseball', 'softball']

  let gameScoringType;
  let gameAllowTies = false;

  if (matchTypes.includes(_sportsModeKey)) {
    gameScoringType = gameScoringTypes.matchPoints
  } else if (halfTypes.includes(_sportsModeKey)) {
    gameScoringType = gameScoringTypes.half
  } else if (quarterTypes.includes(_sportsModeKey)) {
    gameScoringType = gameScoringTypes.quarter
  } else if (inningTypes.includes(_sportsModeKey)) {
    gameScoringType = gameScoringTypes.inning
  }

  return { gameScoringType, gameAllowTies }
}

const updateSeasonalMatchesFromMatches = async (database_fns, sportPermissions, matches, pathViews, key_matches_seasonal, forPlayoff, forceUpdate, forBackup) => {

  // const collectionName = _sportCollections._scores_seasonal

  let collectionName = _sportCollections._matches_seasonal
  let collectionName_bk = _sportCollections._matches_seasonal + '_backup'
  let docName = forPlayoff ? 'playoffMatches' : 'matches'
  // if (forBackup) { collectionName += '_backup' }

  const _refPath = createRefPath_event(pathViews, [collectionName, key_matches_seasonal, docName])
  const scoresCollection = await database_fns.get_collectionExists({ refPath: _refPath })

  const allowUpdate = sportPermissions.any && sportPermissions.matchesList

  if (_.isEmpty(scoresCollection) || forceUpdate) {
    if (matches) {
      const mws_g = _.groupBy(matches, 'levels')
      if (mws_g) {
        Object.keys(mws_g).forEach(async levelKey => {
          const lms = mws_g[levelKey]
          const _matches = {}
          lms.forEach(lm => {
            _matches[lm._itemKey] = lm
            delete _matches[lm._itemKey]._itemKey
          })
          const _refPathM = createRefPath_event(pathViews, [collectionName_bk, key_matches_seasonal, docName, levelKey])
          seasonalHelpers.cleanMatchesForUpdate(_matches)
          const _dataToUpdate = forPlayoff ? { playoffMatches: _matches } : { matches: _matches }
          if (allowUpdate) {
            // await database_fns.update_doc(_refPathM, _dataToUpdate)
            await database_fns.update_docc({
              refPath: _refPathM,
              data: _dataToUpdate,
            })
          } else {
            console.log('_refPathM', _refPathM)
            console.log('_dataToUpdate', _dataToUpdate)
          }
        })
      }
    }
  }
}

const updateSeasonalScoresFromMatches = async (database_fns, sportPermissions, matches, pathViews, key_matches_seasonal, forPlayoff, forceUpdate, forBackup) => {

  // const collectionName = _sportCollections._scores_seasonal

  let collectionName = _sportCollections._matches_seasonal
  let docName = forPlayoff ? 'playoffScores' : 'scores'
  if (forBackup) { collectionName += '_backup' }

  const _refPath = createRefPath_event(pathViews, [collectionName, key_matches_seasonal, docName])
  const scoresCollection = await database_fns.get_collectionExists({ refPath: _refPath })

  const allowUpdate = false// sportPermissions.any && sportPermissions.matchesList

  if (_.isEmpty(scoresCollection) || forceUpdate) {
    if (matches) {
      const mws = getMatchesScores(matches)
      const mws_g = _.groupBy(mws, 'levels')
      if (mws_g) {
        Object.keys(mws_g).forEach(async levelKey => {
          const lms = mws_g[levelKey]
          const _scores = {}
          lms.forEach(lm => {
            _scores[lm._itemKey] = lm
            delete _scores[lm._itemKey]._itemKey
            if (lm.home && !lm.home.id) { delete lm.home.id }
            if (lm.away && !lm.away.id) { delete lm.away.id }
          })
          const _refPathM = createRefPath_event(pathViews, [collectionName, key_matches_seasonal, docName, levelKey])
          const _dataToUpdate = forPlayoff ? { playoffScores: _scores } : { scores: _scores }
          if (allowUpdate) {
            // await database_fns.update_doc(_refPathM, _dataToUpdate)
            await database_fns.update_docc({
              refPath: _refPathM,
              data: _dataToUpdate,
            })
          } else {
            console.log('_refPathM', _refPathM)
            console.log('_dataToUpdate', _dataToUpdate)
          }
        })
      }
    }
  }
}

const getMatchesScores = (matches, prefix) => {
  const mws = {}
  _.forEach(matches, (m, mk) => {
    const { levels, home, away, _itemKey } = m ?? {}
    const _results = m ? m._results : undefined;
    const { score, scores } = _results ?? {}
    if (home && away && (score || scores)) {
      const { id: id_away, name: name_away } = away
      const { id: id_home, name: name_home } = home
      const _mks = !_.isNumber ? mk.split('.') : []
      const _mk = _mks.length === 2 ? prefix + '.' + _mks[1] : mk
      mws[_mk] = {
        _itemKey,
        away: {
          id: id_away,
          name: name_away
        },
        home: {
          id: id_home,
          name: name_home
        },
        levels: levels,
      }
      if (score) { mws[_mk].score = score }
      if (scores) { mws[_mk].scores = scores }
      if (prefix) { delete mws[_mk]._itemKey }
    }
  })
  return mws
}

const getLastestRankings = (rankings) => {
  if (rankings) {
    const _rs = getLastItemSortedByKey(rankings)
    return _rs
  }
}

const isSectionMatch = (m) => {
  if (m && m.home && m.away && (m.home.sections === m.away.sections) && (m.home.levels === m.away.levels) && (!m.exhibition && m._matchCollectionKey !== 'exhibition')) {
    return true
  }
}

/**
 * 
 * @param {object} matches 
 * @param {function} callback 
 * @returns 
 */
const ammendMatchesInfo = (matches, matches_playoffs) => {
  let totalWeeks = 1;
  let firstMatchDate;
  let lastMatchDate;
  const dm = _.groupBy(matches, 'startDate')
  const dms = Object.keys(dm)
  const dmsk = _.sortBy(dms, function (value) { return new Date(value); })
  firstMatchDate = dm ? dmsk[0] : null
  lastMatchDate = dm ? dmsk[dmsk.length - 1] : null
  totalWeeks = weeksBetween(dmsk[0], dmsk[dmsk.length - 1])
  const _matchesG = _.groupBy(matches, '_matchCollectionKey')
  const _playoffMatches = matches_playoffs ? matches_playoffs : _matchesG.playoffs
  return { matches, matches_playoffs: _playoffMatches ? _playoffMatches : {}, totalWeeks, firstMatchDate, lastMatchDate }
}

/**
 * 
 * @param {object} teams 
 * @param {object} matches 
 * @returns teams, sportDistricts, sportLevels
 */
const ammendTeams = (teams, matches, rankings, sportsModeSport, sectionPlayoffTeams) => {
  let sportLevels = []
  const currentRankings = rankings ? getLastItem(rankings) : null
  ammendTeamData(teams, matches, currentRankings)
  const levels = _.groupBy(teams, 'levels')
  delete levels.Non
  ammendTeamSectionInfo(levels, sportsModeSport, sectionPlayoffTeams, matches)
  const lks = Object.keys(levels).sort().reverse()
  sportLevels = lks
  return { teams, sportLevels }
}

const getPlayoffTeams = (teams) => {
  const _playoffTeams = []
  Object.keys(teams).forEach(k => {
    const team = teams[k]
    if (team && team.record && team.record.playoffTeam) {
      _playoffTeams.push(team)
    }
  })
  return _playoffTeams
}


const getTeamHistories = (teams, history) => {

  const teamHistory = {}

  const getYears = (th, items, hr, winner) => {
    items.forEach(item => {
      if (winner) { th.winners.push({ year: item._itemKey, level: hr }) }
      if (!winner) { th.runnerUps.push({ year: item._itemKey, level: hr }) }
    })
  }

  if (teams && history) {
    Object.keys(teams).forEach(tk => {
      const team = teams[tk]
      teamHistory[tk] = {
        winners: [],
        runnerUps: []
      }
      const { name } = team
      Object.keys(history).forEach(hk => {
        const history_level = history[hk]
        convertHelpers.createItemKeys(history_level)
        const winners = _.filter(history_level, { winner: name })
        const runnerUps = _.filter(history_level, { runnerUp: name })
        if (winners && winners.length > 0) { getYears(teamHistory[tk], winners, hk, true) }
        if (runnerUps && runnerUps.length > 0) { getYears(teamHistory[tk], runnerUps, hk) }
      })
    })
  }

  return teamHistory

}

const ammendTeamSectionInfo = (levels, sportsModeSport, sectionPlayoffTeams, matches) => {
  if (levels) {
    Object.keys(levels).forEach(levelKey => {
      const level = levels[levelKey]
      const sections = _.groupBy(level, 'sections')
      if (sections) {
        Object.keys(sections).forEach(sectionKey => {
          const section = sections[sectionKey]
          sortDB.sortSectionStandings(section, null, sectionPlayoffTeams, sportsModeSport, null, null, matches)
        })
      }
    })
  }
}

/**
 * add the team rank and record to teams
 * @param {object} teams
 * @param {object} matches 
 */
const ammendTeamData = (teams, matches, currentRankings) => {
  // const allTeamScores = {}
  // loop the teams 
  if (teams) {
    _.forEach(teams, (team, teamKey) => {
      if (team) {
        // set the base record 
        try {
          team.record = { tm: 0, tsm: 0, mp: 0, w: 0, l: 0, t: 0, sw: 0, sl: 0, st: 0, nsmt: 0, nsmp: 0, nsw: 0, nsl: 0, nst: 0, nssw: 0, nssl: 0, nsst: 0 }
          getTeamRank(team, currentRankings)
          if (matches) {
            team.record = getTeamRecord(matches, teamKey)
          }
        } catch (error) {
          console.log('teams', teams)
        }

      }
    })
  }
}


/**
 * 
 * @param {object} matches 
 * @param {string} teamKey 
 * @returns the record (w, sw, l, sl) for the team
 */
const getTeamRecord = (matches, teamKey) => {

  const currentDate = new Date();
  const twoDaysAgo = new Date(currentDate);
  twoDaysAgo.setDate(currentDate.getDate() - 2);

  const record = {
    totalMatches: null,
    wins: null,
    sectionWins: null,
    losses: null,
    sectionLoses: null,
    ties: null,
    sectionTies: null
  }

  record.totalMatches = _.pickBy(matches, function (m) {
    if (m && m.away && m.home) { return m.away.id === teamKey || m.home.id === teamKey }
  })

  // const xx = _.pickBy(record.totalMatches, function (m) {
  //   if (m && m.away && m.home && m._results && !m._results.loser) { return m }
  // })

  record.totalSectionMatches = _.pickBy(record.totalMatches, function (m) {
    if (m) { return (m.away.sections === m.home.sections && m.away.levels === m.home.levels) }
  })

  record.totalMatchesMissing = _.pickBy(record.totalMatches, (match) => {
    const matchDate = parseDate(match.startDate);
    return matchDate < twoDaysAgo && !match._results;
  });

  record.wins = _.pickBy(record.totalMatches, function (m) {
    if (m && m._results && m._results.winner) { return m._results.winner && m._results.winner.id === teamKey }
  })

  if (record.wins) {
    record.sectionWins = _.pickBy(record.wins, function (m) {
      if (m && m._results && m._results.winner) {
        return m._results.winner && m._results.winner.id === teamKey && isSectionMatch(m)
      }
    })
  }

  record.losses = _.pickBy(record.totalMatches, function (m) {
    if (m && m._results && m._results.loser) { return m._results.loser && m._results.loser.id === teamKey }
  })

  if (record.losses) {
    record.sectionLoses = _.pickBy(record.losses, function (m) {
      if (m && m._results && m._results.loser) {
        return m._results.loser && m._results.loser.id === teamKey && isSectionMatch(m)
      }
    })
  }

  record.ties = _.pickBy(matches, function (m) {
    if (m && m._results && m._results.tied) { return m._results.tied.includes(teamKey) }
  })

  if (record.ties) {
    record.sectionTies = _.pickBy(record.ties, function (m) {
      if (m && m._results && m._results.tied) { return m._results.tied.includes(teamKey) && isSectionMatch(m) }
    })
  }

  getTeamPoints(record)
  // wins
  // sectionWins,
  // losses
  // sectionLoses
  // ties
  // sectionTies

  const teamRecord = {
    tm: Object.keys(record.totalMatches).length, // totalMatches
    tmm: Object.keys(record.totalMatchesMissing).length, // totalMatches
    tsm: Object.keys(record.totalSectionMatches).length, // totalSectionMatches
    w: Object.keys(record.wins).length, // wins
    sw: Object.keys(record.sectionWins).length, // sectionWins
    l: Object.keys(record.losses).length, // losses
    sl: Object.keys(record.sectionLoses).length, // sectionLoses
    t: Object.keys(record.ties).length, // ties
    st: Object.keys(record.sectionTies).length, // sectionTies
  }

  teamRecord.mp = teamRecord.w + teamRecord.l + teamRecord.t
  teamRecord.owp = teamRecord.mp > 0 ? (teamRecord.w / (teamRecord.mp)) : .500
  teamRecord.op = (teamRecord.w * 3) + teamRecord.t

  teamRecord.smp = teamRecord.sw + teamRecord.sl + teamRecord.st
  teamRecord.swp = teamRecord.smp > 0 ? (teamRecord.sw / teamRecord.smp) : .500
  teamRecord.sp = (teamRecord.sw * 3) + teamRecord.st

  teamRecord.mr = teamRecord.tm - teamRecord.mp

  const teamRecord2 = getTR(matches, teamKey, twoDaysAgo)

  teamRecord2.p = record.matchPoints
  teamRecord2.op = record.matchPointsOverall

  return teamRecord2

}

const getTeamPoints = (record) => {

  const matches = {
    winsIn5: _.filter(record.sectionWins, match => match.results && match.results.score && match.results.score.home + match.results.score.away === 5),
    winsNot5: _.filter(record.sectionWins, match => match.results && match.results.score && match.results.score.home + match.results.score.away < 5),
    lossesIn5: _.filter(record.sectionLoses, match => match.results && match.results.score && match.results.score.home + match.results.score.away === 5),
    lossesNot5: _.filter(record.sectionLoses, match => match.results && match.results.score && match.results.score.home + match.results.score.away < 5),
  }

  const overallMatches = {
    winsIn5: _.filter(record.wins, match => match.results && match.results.score && match.results.score.home + match.results.score.away === 5),
    winsNot5: _.filter(record.wins, match => match.results && match.results.score && match.results.score.home + match.results.score.away < 5),
    lossesIn5: _.filter(record.losses, match => match.results && match.results.score && match.results.score.home + match.results.score.away === 5),
    lossesNot5: _.filter(record.losses, match => match.results && match.results.score && match.results.score.home + match.results.score.away < 5),
  }

  const points = {
    winsIn5: matches.winsIn5.length,
    winsNot5: matches.winsNot5.length,
    lossesIn5: matches.lossesIn5.length,
    lossesNot5: matches.lossesNot5.length,
  }

  const overallPoints = {
    winsIn5: overallMatches.winsIn5.length,
    winsNot5: overallMatches.winsNot5.length,
    lossesIn5: overallMatches.lossesIn5.length,
    lossesNot5: overallMatches.lossesNot5.length,
  }

  points.total = (points.winsNot5 * 3) + (points.winsIn5 * 2) + (points.lossesIn5 * 1)
  points.totalOverall = (overallPoints.winsNot5 * 3) + (overallPoints.winsIn5 * 2) + (overallPoints.lossesIn5 * 1)

  record.matchPoints = points.total
  record.matchPointsOverall = points.totalOverall

}

const getTR = (matches, teamKey, twoDaysAgo) => {

  const record = {};

  record.totalMatches = _.pickBy(matches, m => (m?.away?.id === teamKey || m?.home?.id === teamKey));
  record.totalSectionMatches = _.pickBy(record.totalMatches, m => (m?.away?.sections === m?.home?.sections));

  record.totalMatchesMissing = _.pickBy(record?.totalMatches, match => {
    const matchDate = parseDate(match.startDate);
    return matchDate < twoDaysAgo && !match._results;
  });

  record.wins = _.pickBy(record.totalMatches, m => (m?._results?.winner?.id === teamKey));
  record.sectionWins = _.pickBy(record.wins, m => (isSectionMatch(m)));
  record.losses = _.pickBy(record.totalMatches, m => (m?._results?.loser?.id === teamKey));
  record.sectionLoses = _.pickBy(record.losses, m => (isSectionMatch(m)));
  record.ties = _.pickBy(matches, m => (m?._results?.tied?.includes(teamKey)));
  record.sectionTies = _.pickBy(record.ties, m => (isSectionMatch(m)));

  const teamRecord = {
    tm: _.size(record.totalMatches),
    tmm: _.size(record.totalMatchesMissing),
    tsm: _.size(record.totalSectionMatches),
    w: _.size(record.wins),
    sw: _.size(record.sectionWins),
    l: _.size(record.losses),
    sl: _.size(record.sectionLoses),
    t: _.size(record.ties),
    st: _.size(record.sectionTies),
  };

  teamRecord.mp = teamRecord.w + teamRecord.l + teamRecord.t
  teamRecord.owp = teamRecord.mp > 0 ? (teamRecord.w / (teamRecord.mp)) : .500
  teamRecord.op = (teamRecord.w * 3) + teamRecord.t

  teamRecord.smp = teamRecord.sw + teamRecord.sl + teamRecord.st
  teamRecord.swp = teamRecord.smp > 0 ? (teamRecord.sw / teamRecord.smp) : .500
  teamRecord.sp = (teamRecord.sw * 3) + teamRecord.st

  teamRecord.mr = teamRecord.tm - teamRecord.mp

  return teamRecord
}


function parseDate(dateString) {
  try {
    const [month, day, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day); // Note: months are 0-based
  } catch (error) {

  }

}

const getTeamRank = (team, currentRankings) => {
  const { name, levels } = team ?? {}
  if (currentRankings) {
    Object.keys(currentRankings).forEach(crKey => {
      if (crKey === levels) {
        const cr = currentRankings[crKey]
        if (cr && cr.includes(name)) {
          team.currentRank = cr.indexOf(name) + 1
        }
      }
    })
  }
}

function weeksBetween(d1, d2) {
  const weeks = Math.round((new Date(d2) - new Date(d1)) / (7 * 24 * 60 * 60 * 1000))
  const totalWeeks = weeks + 2
  return totalWeeks
}

const ammendScoresWithScores = (matches, scores) => {

  if (scores && matches) {
    _.forEach(scores, (scoreItem, scoreKey) => {
      if (matches[scoreKey]) {
        const match = matches[scoreKey]
        const { score, scores } = scoreItem ?? {}
        if (match && match.results && (score || scores)) {
          match._results_fromScores = {}
          if (score) { match._results_fromScores.score = score }
          if (scores) { match._results_fromScores.scores = scores }
        }
      }
    })
  }
}

const getPendingMatchesInfo = (matchDataUpdates, matches_playoffs, teams, matches_gs) => {

  const _updatedMatches = {}
  let count = 0

  // loop the matches_playoffs
  _.forEach(matches_playoffs, (playoffMatch) => {

    // get the pending object
    const { pending, levels } = playoffMatch ?? {}

    if (pending) {
      _.forEach(pending, (pt, ptk) => {
        // find the playoff match in question
        const pendingMatch = _.find(matches_playoffs, pm => pm.levels === levels && pm.poolKey === pt.poolKey && pm.matchNumber === pt.matchNumber && pm._results && pm._results.complete)
        if (pendingMatch) {
          const { _results } = pendingMatch
          const { winner } = _results
          if (winner && !playoffMatch[ptk]) {
            playoffMatch[ptk] = winner
            playoffMatch._hasUpdates = true
            count++
          }
        }
      })
    }
  })

  return _updatedMatches

}

/**
 * 
 * @param {object} match the match     
 * @param {object} playoffMatches a list of existing playoff matches 
 * @param {*} pendings 
 * @param {*} teams 
 * @returns 
 */
const getPendingMatchInfo = (match, matches_playoffs, pendings, teams) => {

  console.log('match', match)

  // this is the match that was updated 
  // const { home, away, poolKey, levels: level_match, pending, _results, _matchCollectionKey } = match ?? {}

  // const { score, scores } = _results ?? {}

  // const { seed: seed_away } = away ?? {}
  // const { seed: seed_home } = home ?? {}

  // const { home: pending_home, away: pending_away } = pending ?? {}
  // const { originalSeed: originalSeed_away } = pending_away ?? {}
  // const { originalSeed: originalSeed_home } = pending_home ?? {}

  // const _seed_away = originalSeed_away ? originalSeed_away : seed_away
  // const _seed_home = originalSeed_home ? originalSeed_home : seed_home

  const xxx = findMatchingPlayoffMatch(matches_playoffs, match)
  return xxx

  // const match_playoffHome = getWinnerMatch(playoffMatches, match, level_match, poolKey, _seed_home, _results, pendings, teams)
  // const match_playoffAway = getWinnerMatch(playoffMatches, match, level_match, poolKey, _seed_away, _results, pendings, teams)

  // if (match_playoffHome) {
  //   if (!pendings.matchWinners[match_playoffHome._itemKey]) {
  //     pendings.matchWinners[match_playoffHome._itemKey] = match_playoffHome
  //   } else {
  //     pendings.matchWinners[match_playoffHome._itemKey] = { ...pendings.matchWinners[match_playoffHome._itemKey], ...match_playoffHome }
  //   }
  // }

  // if (match_playoffAway) {
  //   if (!pendings.matchLosers[match_playoffAway._itemKey]) {
  //     pendings.matchLosers[match_playoffAway._itemKey] = match_playoffHome
  //   } else {
  //     pendings.matchLosers[match_playoffAway._itemKey] = { ...pendings.matchWinners[match_playoffAway._itemKey], ...match_playoffAway }
  //   }
  // }

  // pendings.results = {
  //   score,
  //   scores
  // }

  // return { _matchCollectionKey }
}

function findMatchingPlayoffMatch(matches_playoffs, match) {

  // Destructure poolKey and winner seed from the input match

  const { poolKey, _results } = match ?? {}
  const { winner } = _results ?? {}
  const { seed } = winner ?? {}

  // Use Lodash find to locate the matching playoffMatch
  const foundMatch = _.find(matches_playoffs, playoffMatch => {
    const { pending } = playoffMatch;
    // Ensure poolKey matches and safely check originalSeed on pending.home/away if they exist
    return (playoffMatch.poolKey === poolKey) &&
      pending &&
      ((pending.home?.originalSeed === seed) || (pending.away?.originalSeed === seed));
  });

  // Determine if the match is home or away based on the seed
  if (foundMatch) {
    const seedType = foundMatch.pending.home.originalSeed === seed ? 'home' : 'away';
    foundMatch[seedType] = winner;  // Set the winner to the appropriate property (home or away) 
    foundMatch._pendingUpdated = true
    foundMatch._winner = winner
    foundMatch._match = match
    return { playoffMatch: foundMatch, seedType, winner };
  }

  // Return null if no matching playoffMatch was found
  return {};
}

/**
 * 
 * @param {object} matches_playoffs 
 * @param {string} level_match 
 * @param {string} poolKey 
 * @param {number} seed 
 * @param {object} winner 
 * @param {object} pendings 
 * @param {object} _results 
 * @param {object} teams 
 * @returns 
 */
// const getWinnerMatch = (matches_playoffs, match) => { 
//   const xxx = findMatchingPlayoffMatch(matches_playoffs, match) 
// }

// const ammendPendings = (pendingMatch, _levelMatch, _results, pendings, homeOrAway) => {

//   const teamKey = _pendingPrefix + pendingMatch._itemKey + '.' + homeOrAway;
//   const { winner, scoreDisplays, score, scores } = _results ?? {}
//   const { full: results_full } = scoreDisplays ?? {}

//   pendings.levelMatchUpdates[_levelMatch][teamKey] = winner;
//   pendings.levelMatchUpdates[_levelMatch][teamKey]._existingInfo = {
//     full: results_full,
//     exists: pendingMatch._homeAlreadyExists ? pendingMatch._existingsName : null,
//   };

//   const matchTeamsKey = _pendingPrefix + pendingMatch._itemKey + '.teams';

//   if (!pendings.levelMatchUpdates[_levelMatch][matchTeamsKey]) {
//     pendings.levelMatchUpdates[_levelMatch][matchTeamsKey] = [];
//   }
//   pendings.levelMatchUpdates[_levelMatch][matchTeamsKey].push(winner.id);

//   return { matchKey: pendingMatch._itemKey, matchTeamsKey }
// }

// const ammendPendingMatch = (pendingMatch, _results, winnerTeamType, pendings) => {

//   const { winner, score, scores } = _results
//   const hasAorH = pendingMatch[winnerTeamType] && pendingMatch[winnerTeamType].seed ? true : false

//   // Update winnerTeamType match details if it exists
//   if (pendingMatch && (!hasAorH)) {
//     const result = { score, scores }
//     const { levels } = pendingMatch;
//     pendingMatch[winnerTeamType] = winner;
//     pendingMatch._hasUpdates = true
//     pendingMatch._isUpdated = true
//     pendingMatch.result = result
//     // update the teams array
//     if (pendingMatch.away && pendingMatch.away.id && pendingMatch.home && pendingMatch.home.id) {
//       pendingMatch.teams = [pendingMatch.home.id, pendingMatch.home.id]
//     }

//     // Initialize levelMatchUpdates for the match level if not already present
//     if (!pendings.levelMatchUpdates[levels]) {
//       pendings.levelMatchUpdates[levels] = {};
//     }
//   }

// }

/**
 * Finds the first playoff match that matches the specified seed and other criteria.
 *
 * @param {Array} matches_playoffs - Array of playoff match objects to search through.
 * @param {string} levels - The match level to match against the `levels` property in each object.
 * @param {string} poolKey - The pool key to match against the match's `poolKey` property.
 * @param {string} awayOrHome - Specifies whether to check the "away" or "home" team's data.
 * @param {number|string} seed - The seed to match against either the away or home team's seed.
 * @returns {string|null|undefined} - The away team's ID if a matching playoff match is found; otherwise, `null` or `undefined`.
 */
// const findMatchTeamKeyBy_seed = (matches_playoffs, levels, poolKey, awayOrHome, seed) => {

//   const match = _.find(matches_playoffs, ({ home, away, poolKey: pk, levels: matchLevel, results }) => {
//     // Check if the match level matches the specified levels
//     const isLevelMatch = levels === matchLevel;

//     // Determine if the specified seed matches either the away or home team's seed
//     const isSeedMatch = (away && away.seed === parseInt(seed)) || (home && home.seed === parseInt(seed));

//     // Ensure the pool key matches the match's pool key
//     const isPoolKeyMatch = poolKey === pk;

//     // Return the away team's ID if all conditions are met
//     return isLevelMatch && isSeedMatch && isPoolKeyMatch;

//   });

//   if (match) {
//     switch (awayOrHome) {
//       case 'away':
//         return match?.away?.id
//       case 'home':
//         return match?.home?.id
//       default:
//       // nothing
//     }
//   }
// }


/**
 * Finds the first playoff match that meets specific criteria related to pending match details.
 *
 * @param {Array} matches_playoffs - Array of playoff match objects to search through.
 * @param {string} level_match - The match level to match against the `levels` property in each object.
 * @param {string} poolKey - The pool key to match within the `pending` property for the specified `awayOrHome` team.
 * @param {string} awayOrHome - Specifies whether to check the "away" or "home" team's data within `pending`.
 * @param {number|string} seed - The original seed to match within the specified `awayOrHome` team's pending data.
 * @returns {Object|undefined} - The first playoff match object that matches all criteria, or `undefined` if none found.
 */
// const findMatchBy_pendingSeed = (matches_playoffs, level_match, poolKey, awayOrHome, seed) =>
//   _.find(matches_playoffs, ({ pending, results, levels }) =>
//     !results &&
//     levels === level_match &&
//     pending?.[awayOrHome]?.poolKey === poolKey &&
//     parseInt(pending[awayOrHome]?.originalSeed) === parseInt(seed)
//   );

const getPrePendingMatches = (match, matches_playoffs) => {

  const data_match = {}

  // this is the match that was updated
  const { levels: level_match, pending, _matchCollectionKey, _itemKey } = match ?? {}

  const { home: pending_home, away: pending_away } = pending ?? {}

  const { matchNumber: matchNumber_home, poolKey: poolKey_home } = pending_home ?? {}
  const { matchNumber: matchNumber_away, poolKey: poolKey_away } = pending_away ?? {}

  // get the MATCH from matches_playoffs for the pending HOME team
  const preMatch = {
    home: getPrePendingMatch(level_match, matches_playoffs, poolKey_home, matchNumber_home),
    away: getPrePendingMatch(level_match, matches_playoffs, poolKey_away, matchNumber_away)
  }

  if (preMatch.home && preMatch.home.length === 1 && preMatch.home[0].results && preMatch.home[0].results.winner) {
    data_match[_pendingPrefix + _itemKey + '.home'] = preMatch.home[0].results.winner
  }

  if (preMatch.away && preMatch.away.length === 1 && preMatch.away[0].results && preMatch.away[0].results.winner) {
    data_match[_pendingPrefix + _itemKey + '.away'] = preMatch.away[0].results.winner
  }

  return { preMatch, data_match, _matchCollectionKey }
}

/**
 * 
 * @param {string} level_match 
 * @param {object} matches_playoffs 
 * @param {string} homeOrAway 
 * @param {string} poolKey 
 * @param {number} originalSeed 
 * @returns the pending match
 * @description filters the playoff matches for a match on the `poolKey` and the `originalSeed`
 */
const getPrePendingMatch = (level_match, matches_playoffs, poolKey, matchNumber) => _.filter(matches_playoffs, function (pm) {
  const results = pm ? pm._results : undefined;
  const { winner } = results ?? {}
  return level_match === pm.levels && pm.poolKey === poolKey && pm.matchNumber === matchNumber && winner
})


const getDatesBetweenRange = (startDate, endDate) => {
  const dates = [];
  let currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    // Format the date as MM/DD/YYYY
    const formattedDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}/${currentDate.getFullYear()}`;
    dates.push(formattedDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
};

const generateDatesByYear = (years, season) => {

  const datesByYear = {};

  const _season = season ? season : 'fall'

  years.forEach(year => {
    let start, end;

    switch (_season.toLowerCase()) {
      case 'fall':
        // Fall: Start on the 3rd Monday of August and end on December 31
        const yearFall = year - 1;
        start = new Date(yearFall, 7, 15 + (8 - new Date(yearFall, 7, 15).getDay()) % 7); // 3rd Monday of August
        end = new Date(yearFall, 11, 31); // December 31
        break;

      case 'winter':
        // Winter: Start on November 15 of the previous year and end on March 31
        const yearWinter = year - 1;
        start = new Date(yearWinter, 10, 15); // November 15
        end = new Date(year, 2, 31); // March 31
        break;

      case 'spring':
        // Spring: Start on April 1 and end on June 15
        start = new Date(year, 3, 1); // April 1
        end = new Date(year, 5, 15); // June 15
        break;
      default:
        throw new Error("Invalid season. Please use 'fall', 'winter', or 'spring'.");
    }

    datesByYear[year] = getDatesBetweenRange(start, end);
  });

  return datesByYear;
};

export const sportsHelpers = {
  ammendMatchDayMatches,
  createMatchUpdateData,
  ammendMatchesCollectionKeys,
  ammendMatchesFromDbResults,
  ammendMatchesInfo,
  ammendMatchTeamNames,
  ammendScoresWithScores,
  ammendTeams,
  copyTeamDataToClipboard,
  createSportAbr,
  createTeamInitials,
  generateDatesByYear,
  getLastestRankings,
  getMatch_flat,
  getMatchDateKeys,
  getMatches_flat,
  getMatchesScores,
  getPendingMatchesInfo,
  getPendingMatchInfo,
  getPlayoffTeams,
  getPrePendingMatches,
  getScoreType,
  getSportSeasonType,
  getTeamHistories,
  getTeams_flat,
  getWheres_sports,
  isSectionMatch,
  updateSeasonalMatchesFromMatches,
  updateSeasonalScoresFromMatches,
}